import { Injectable } from '@angular/core';
import { Salary } from '../model';
import { BaseService } from '../../shared/baseService';

@Injectable({
    providedIn: 'root'
})

export class SalariesService extends BaseService<Salary> {
    constructor() {
        super('Salary');
    }
}
